/**
 * clone()이 복제하지 않는 커스텀 속성을 원본→복사본으로 수동 전달
 */
const CUSTOM_KEYS = [
  'wordWrap', 'splitByGrapheme', '_marL', '_marR', '_marT', '_marB',
  '_isFrame', '_isEmptyFrame', '_frameShapeType', '_frameLocked',
  '_frameImageScale', '_frameWidth', '_frameHeight',
  '_origLeft', '_origTop', '_origScaleX', '_origScaleY',
  '_origWidth', '_origHeight', '_origAngle', '_origCropX', '_origCropY',
];

export const copyCustomProps = (src, dst) => {
  if (!src || !dst) return;
  CUSTOM_KEYS.forEach(key => {
    if (src[key] !== undefined) dst[key] = src[key];
  });
  // wordWrap=false → _wordJoiners 복원 (RegExp는 clone 불가)
  if (dst.wordWrap === false && (dst.type === 'textbox' || dst.type === 'i-text')) {
    dst._wordJoiners = /\x00/; // eslint-disable-line no-control-regex
    dst.initDimensions();
  }
  // 그룹 내부 자식도 재귀 처리
  if (src.type === 'group' && src.getObjects && dst.getObjects) {
    const srcChildren = src.getObjects();
    const dstChildren = dst.getObjects();
    srcChildren.forEach((s, i) => { if (dstChildren[i]) copyCustomProps(s, dstChildren[i]); });
  }
};
